<!-- Permissions -->
<div [appEnforcePermission]="authConfig.investigationRequestsCreate"
  #investigationRequestsCreate="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.investigationDocumentsCreate"
  #investigationDocumentsCreate="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.investigationReportsCreate" #investigationReportsCreate="appEnforcePermission">
</div>
<div [appEnforcePermission]="authConfig.investigationCommentsCreate"
  #investigationCommentsCreate="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.investigationAdminCommentsView"
  #investigationAdminCommentsView="appEnforcePermission"></div>
<!-- Permissions -->
<section>
  <div class="page-filters">
    <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }" [cols]="['repeat(5,minmax(0,1fr))']">
      <kendo-gridlayout-item>
        <app-user-select-kendo label="Search" [userViewFilter]="userViewFilter" placeholder="Search staff member"
          [userId]="filterValue(filterTypes.User)" [includeInactive]="false"
          (selectionChanged)="setFilters($event?.id, filterTypes.User)"
          (enteredPressed)="filterTable()"></app-user-select-kendo>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item>
        <div class="kendo-formfield">
          <kendo-label [for]="rType" text="Request Type"></kendo-label>
          <kendo-dropdownlist #rType [data]="requestTypes" textField="name" valueField="id" fillMode="outline"
            [valuePrimitive]="true" (keydown.enter)="enterPress(rType)"
            [defaultItem]="{ id: null, name: 'All request types' }" [value]="filterValue(filterTypes.Type)"
            [popupSettings]="{
              appendTo: 'component',
              animate: false,
              width: 250
            }" (selectionChange)="requestTypeChange($event)">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span *ngIf="dataItem?.name === 'All request types'" class="placeholder">
                {{ dataItem.name }}
              </span>
              <span *ngIf="dataItem?.name !== 'All request types'" class="not-placeholder">
                {{ dataItem.name }}
              </span>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item>
        <div class="kendo-formfield">
          <kendo-label [for]="Priority" text="Priority"></kendo-label>
          <kendo-dropdownlist #Priority [data]="investigationPriorities" textField="name" valueField="id"
            fillMode="outline" (keydown.enter)="enterPress(Priority)" [valuePrimitive]="true"
            [defaultItem]="{ key: null, name: 'All priorities' }" [value]="filterValue(filterTypes.Priority)"
            [popupSettings]="{
              appendTo: 'component',
              animate: false,
              width: 250
            }" (selectionChange)="
              setFilters(
                $event?.name === 'All' ? undefined : $event?.id,
                filterTypes.Priority
              )
            ">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span *ngIf="dataItem?.name === 'All priorities'" class="placeholder">
                {{ dataItem?.name }}
              </span>
              <span *ngIf="dataItem?.name !== 'All priorities'" class="not-placeholder">
                {{ dataItem?.name }}
              </span>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item class="filter-actions" [colSpan]="2" [col]="0" [row]="0">
        <div class="comments-filter mr-16">
          <kendo-label text=""></kendo-label>
          <div class="comment-toggle-group">
            <kendo-button kendoButton [themeColor]="showComments === true ? 'light' : 'base'" fillMode="solid"
              iconClass="fa-solid fa-comment" (click)="toggleCommentExpand(true)"></kendo-button>
            <kendo-button kendoButton [themeColor]="showComments === false ? 'light' : 'base'" fillMode="solid"
              iconClass="fa-solid fa-comment-slash" (click)="toggleCommentExpand(false)"></kendo-button>
          </div>
        </div>
        <div class="mr-16" *ngIf="showCheckboxSelection">
          <kendo-label text=""></kendo-label>
          <div *ngIf="filterValue(filterTypes.Type) === getRequestTypeId('Reactivate Investigation')">
            <kendo-button kendoButton themeColor="light" fillMode="solid" size="medium"
              [disabled]="!selectedRequest?.length" (click)="reactivateSelectedRequests()">Update
              Requests</kendo-button>
          </div>
          <div *ngIf="filterValue(filterTypes.Type) === getRequestTypeId('Request to close file')">
            <kendo-button kendoButton themeColor="light" fillMode="solid" size="medium"
              [disabled]="!selectedRequest?.length" (click)="closeSelectedRequests()">Close Files</kendo-button>
          </div>
        </div>
        <div class="applied-filter mr-16">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="filterTable()">Apply
              Filters</kendo-button>
          </div>
        </div>
        <div class="clear-filter mt-5">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="clearFilter()">Clear
              All</kendo-button>
          </div>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
    <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }" [cols]="['repeat(1,minmax(0,1fr))']">
      <kendo-gridlayout-item>
        <app-market-loss-filter [checked]="filterValue(filterTypes.MarketLoss)" (filter)="filterTable()"
          (checkedChange)="setCheckedFilters($event.checked, filterTypes.MarketLoss)"></app-market-loss-filter>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>

  <kendo-grid class="pending-request" [data]="{
      data: tableData,
      total: (dataSource?.pageInfo$ | async)?.totalCount
    }" [pageSize]="pageOptions?.limit" [skip]="pageOptions?.offset" [pageable]="{
      buttonCount: 6,
      type: 'numeric',
      pageSizes: [5, 10, 25, 100],
      previousNext: true,
      responsive: true,
      position: 'bottom'
    }" (pageChange)="pageChange($event)" [sortable]="true" [sort]="sort" (sortChange)="sortChange($event)"
    [navigatable]="false" [kendoGridExpandDetailsBy]="'id'" [(expandedDetailKeys)]="expandedDetailKeys"
    [selectable]="{checkboxOnly: true, mode: 'multiple' }" kendoGridSelectBy="id" [(selectedKeys)]="selectedRequest">
    <kendo-grid-checkbox-column *ngIf="showCheckboxSelection" [width]="5">
      <ng-template kendoGridHeaderTemplate="" let-dataItem let-rowIndex="rowIndex">
        <input type="checkbox" kendoCheckBox [checked]="tableData?.length === selectedRequest?.length
    " (click)="checkAll($event.target)" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <ng-container *ngIf="dataItem?.RequestType?.name === 'Reactivate Investigation' || dataItem?.RequestType?.name === 'Request to close file'">
          <input type="checkbox" kendoCheckBox [checked]="selectedRequest.includes(dataItem.id)"
            (click)="onRequestCheckboxChecked($event?.target?.checked, dataItem)" />
        </ng-container>
      </ng-template>
    </kendo-grid-checkbox-column>
    <kendo-grid-column field="nefcoNumber" title="Investigation" [width]="20" class="id-column" [sortable]="false"
      [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem?.Investigation"
          [type]="'investigation'"></app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="name" title="Priority" [width]="7" [sortable]="false" [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem?.Investigation"
          [type]="'priority'"></app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="Status" title="Inv. Status" [width]="7" [sortable]="false" [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{
        dataItem?.Investigation?.status
        ? investigationStatusNames[dataItem?.Investigation?.status]
        : "-"
        }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="InvestigationStaff" title="Assigned" [width]="20" [sortable]="false"
      [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="
            dataItem?.Investigation?.InvestigationStaff?.length;
            else noStaff
          ">
          <ng-container *ngFor="let person of dataItem.Investigation?.InvestigationStaff">
            <a target="_blank" [routerLink]="['/staff/', person.User?.id]" tel=""
              class="text-decoration merged-column-highlight text-overflow">
              {{ person.User | fullName }} ({{ person.Role.title }})
            </a>
            <br />
          </ng-container>
        </ng-container>
        <ng-template #noStaff>-</ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="name" title="Request Type" [width]="15" [sortable]="false" [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="text-overflow">{{
          dataItem?.RequestType?.name || "-"
          }}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="CREATED_AT" title="Request Status" [width]="10" [sortable]="true"
      [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [style.line-height]="'20px'">
        {{ RequestStatuses[dataItem?.Status] || "-" }}
        <br />
        {{ dataItem?.createdAt | customDate : "MM/dd/yyyy" }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="current" title="Current" [width]="20" [sortable]="false" [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem?.Investigation" [type]="'current'"
          [investigationCommentsCreateEnabled]="investigationCommentsCreate?.enabled"
          (commentAdd)="addComment($event)"
          (documentsReportsOpen)="goToInvestigationDocumentsReports($event.event, $event.investigation)"></app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="Action" title="Action" [width]="10" [sortable]="false" [headerClass]="'nocursor'"
      *ngIf="investigationRequestsCreate?.enabled && investigationDocumentsCreate?.enabled && investigationReportsCreate?.enabled">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton themeColor="primary" fillMode="link" (click)="updateRequest(dataItem)">
          Update Request
        </button>
      </ng-template>
    </kendo-grid-column>

    <!-- Comments -->
    <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="displayComments">
      <kendo-grid [data]="dataItem?.Investigation?.Comments.slice(0, 5)" [pageable]="false" [scrollable]="'none'"
        [className]="'detail-items'">
        <kendo-grid-column field="createdAt" title="Date/Time" [width]="30" [sortable]="false"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span style="text-transform: lowercase">
              {{ dataItem?.createdAt | customDate : "MM/dd/yy, h:mma" }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="text" title="Comment" [width]="120" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="text-overflow" [style.font-weight]="dataItem?.adminOnly ? 'bold' : 'normal'">{{ dataItem?.text
              }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="CreatedBy" title="User" [width]="50" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.CreatedBy | fullName }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="investigationAdminCommentsView?.enabled" title="#" [width]="30" [sortable]="false"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span><b>{{ dataItem?.adminOnly ? 'Admin Only' : '-' }}</b></span>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
      <kendo-grid [data]="dataItem?.StatusHistory?.slice(0, 5)" [pageable]="false" [scrollable]="'none'"
        [className]="'detail-items'">
        <kendo-grid-column field="createdAt" title="Updated" [width]="30" [sortable]="false"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span style="text-transform: lowercase">
              {{ dataItem?.createdAt | customDate : "MM/dd/yy, h:mma" }}
            </span>
          </ng-template>
        </kendo-grid-column>
                <kendo-grid-column field="CreatedBy" title="Updated By" [width]="50" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.CreatedBy | fullName }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="text" title="Comment" [width]="120" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="text-overflow">{{ dataItem?.comment
              }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Status" [width]="30" [sortable]="false"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span><b>{{ dataItem?.name || '-' }}</b></span>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </ng-template>
    <!-- No record -->
    <ng-template kendoGridNoRecordsTemplate>
      <p class="mt-24 mb-24">There are no results to display.</p>
    </ng-template>
  </kendo-grid>
</section>
